import React from 'react';
import Icon from './Icon';

export default function PhotoInfoOverlay({ author, date, className = '' }) {
  return (
    <div
      className={`inline-flex items-center ${className}`}
      style={{
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 12,
        paddingBottom: 12,
        background: 'linear-gradient(180deg, rgba(31,20,16,0.76) 0%, rgba(31,20,16,0.68) 100%)',
        border: '1px solid rgba(255,255,255,0.24)',
        boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
        backdropFilter: 'blur(16px) saturate(130%)',
        WebkitBackdropFilter: 'blur(16px) saturate(130%)',
        borderRadius: 100,
        gap: 24,
        justifyContent: 'center',
        maxWidth: 'min(92vw, 560px)',
      }}
    >
      <div className="flex items-center gap-2">
        <Icon name="author" size={16} color="#FFFFFF" />
        <span style={{ color: '#FFFFFF', fontSize: 15, fontFamily: 'Poppins', fontWeight: 500, textShadow: '0 1px 2px rgba(0,0,0,0.35)' }}>
          {author}
        </span>
      </div>
      <span
        aria-hidden
        style={{
          width: 1,
          height: 16,
          background: 'rgba(255,255,255,0.85)',
          display: 'inline-block',
          borderRadius: 1,
        }}
      />
      <span style={{ color: '#FFFFFF', fontSize: 15, fontFamily: 'Poppins', fontWeight: 500, textShadow: '0 1px 2px rgba(0,0,0,0.35)' }}>
        {date}
      </span>
    </div>
  );
}


